import { jsx as _jsx } from "react/jsx-runtime";
import { extendVariants, Badge as HeroBadge } from '@heroui/react';
const EnhancedBadge = extendVariants(HeroBadge, {
    variants: {
        variant: {
            solid: {},
            flat: {},
            faded: {},
            shadow: {},
            notification: {
                badge: 'bg-primary text-primary-foreground border-primary'
            },
            profit: {
                badge: 'bg-success text-success-foreground border-success'
            },
            loss: {
                badge: 'bg-danger text-danger-foreground border-danger'
            },
            online: {
                badge: 'bg-success text-success-foreground border-success'
            },
            offline: {
                badge: 'bg-default-300 text-default-foreground border-default-300'
            }
        }
    },
    defaultVariants: {
        color: 'default',
        size: 'md',
        variant: 'solid',
        shape: 'rectangle',
        placement: 'top-right'
    },
    compoundVariants: [
        {
            variant: ['profit', 'loss', 'online', 'offline', 'notification'],
            class: 'font-medium border'
        }
    ]
});
export const Badge = (props) => {
    return _jsx(EnhancedBadge, { ...props });
};
export default Badge;
//# sourceMappingURL=Badge.js.map